<template>
  <div class="row">
    <div class="col s7">
      <calendar></calendar>
      <template v-if="role != 'ddd_customer'">
        <h5 style="margin-top: 15px; padding-left: 1em;">{{$t('desktop.planned_maintenaces')}}</h5>
        <div style="border: 2px solid black; margin: 15px; padding: 15px;">
          <table>
            <tr>
              <th>{{$t('desktop.date')}}</th>
              <th>{{$t('desktop.object')}}</th>
              <th>{{$t('desktop.procedure')}}</th>
              <th>{{$t('desktop.devices')}}</th>
            </tr>
            <template  v-if="loaded">
            <tr v-for="inspection in maintenaces">
                <td>{{inspection[0][1] | formatDate}}</td>
                <td><a :href='"#/customers/"+inspection[0][3]+"/places/"+inspection[0][4]'>{{inspection[0][0]}}</a></td> 
                <td>{{inspection[0][2]}}</td>
                <td style="max-width: 1em; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                  <popup
                    :text="inspection[1].join(', ')"
                    v-bind:title="inspection[0][1] + ', ' + inspection[0][0] + ' ' + inspection[0][2]"
                    v-bind:lines="[$t('desktop.devices') + ':', inspection[1].join(', ')]"
                  />
                </td>
              </tr>
              <tr v-if="maintenaces.length == 0"><td colspan="4" rowspan="5">{{$t('desktop.no_planned_maintenaces')}}</td></tr>
            </template>
            <preloader v-else n="4"/>
          </table>
        </div>
      </template>
    </div>
    <div class="col s5">
      <template v-if="role != 'ddd_customer'">
        <div style="border: 2px solid #ddd; margin: 15px; padding: 15px;">
          <h6>{{company_name}}</h6>
          <h6>{{$t('desktop.plan')}}: {{license.variant}}</h6>
          <h6>{{$t('desktop.license_active_until')}} {{license.ends_at | formatDate}}</h6>
            <div class="progress">
                <div class="determinate green" style="width: 70%">{{license.used}} / {{license.limit || "∞"}}</div>
            </div>
        </div>
      <p class="leftdays" style="color: #C22026;" v-if="leftDays <= leftTreshold">Pozostało {{leftDays}} dni</p>
      </template>
      <h5 style="margin-top: 0px; padding-left: 1em;">{{$t('desktop.inspections')}}</h5>
      <div style="border: 2px solid black; margin: 15px; padding: 15px;">
        <table>
          <tr>
            <th>{{$t('desktop.date')}}</th>
            <th>{{$t('desktop.object')}}</th>
            <th>{{$t('desktop.score')}}</th>
            <th></th>
          </tr>
          <template  v-if="loaded">
            <tr v-for="inspection in inspections">
                <td><a :href='"#/customers/"+inspection.customer_id+"/places/"+inspection.place_id'>{{inspection.date | formatDate}}</a></td>
                <td><a :href='"#/customers/"+inspection.customer_id+"/places/"+inspection.place_id'>{{inspection.place_name}}</a></td>
                <td><a :href='"#/customers/"+inspection.customer_id+"/places/"+inspection.place_id'>{{inspection.total || 0}}/{{inspection.out_of || 0}}</a></td>
                <td style="text-align: center;"><a :href='"#/customers/"+inspection.customer_id+"/places/"+inspection.place_id+"/inspections/"+inspection.id'><span class="material-icons dp6">equalizer</span></a></td>
                <td style="text-align: center;"><a :href='"#/customers/"+inspection.customer_id+"/places/"+inspection.place_id+"/inspections/"+inspection.id+"/summary"'><span class="material-icons dp6">featured_play_list</span></a></td>
                <td style="text-align: center;"><a :href='"#/customers/"+inspection.customer_id+"/places/"+inspection.place_id+"/inspections/"+inspection.id+"/recommendations"'><span class="material-icons dp6">check_box</span></a></td>
            </tr>
          </template>
          <preloader v-else n="4"/>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import axios from 'axios';
export default {
  data: function () {
    return {
      date: moment(),
      inspections: [],
      maintenaces: [],
      loaded: false,
      leftTreshold: 14
    }
  },
  props: { license: { type: Object, default(){ return {variant: "none",ends_at: moment(),used: 0, limit: 0 }; } }, company_name: String, role: String },
  created() {
    this.load();
  },
  computed: {
    leftDays: function(){
      return moment(this.license.ends_at).diff(moment(), 'days')
    }
  },
  methods: {
    async load(){
      var result = await axios.get("/inspections.json?limit=10")
      this.inspections = result.data;
      if(this.role != 'ddd_customer'){
        result = await axios.get("/desktop/maintenaces.json?limit=10")
        this.maintenaces = result.data;
      }
      this.loaded = true;
    }
  }
}
</script>

<style scoped>
.login_button{
  color: red;
}
p {
  font-size: 2em;
  text-align: center;
}
nav {
  background-color: #626262;
  height: 100px;
}
nav a{
  margin: 15px;
}
a{
  color: #000;
}
.progress {
    height: 25px;
    background-color: white;
    border: 1px solid #bbb;
}
.determinate{
  padding-left: 15px;
}
.green {
    background-color: #00CC66 !important;
}
/deep/ tr th {
  text-transform: uppercase;
}
/deep/ .oldmobi{
    color: white !important;
    text-transform: none !important;
    margin: 32px;
}
.leftdays{
  font-size: 1.5em;
  text-align: left;
  margin: 1em;
}
</style>
